import { render } from "./ConfirmDialogOneButton.vue?vue&type=template&id=8fcab0a2"
import script from "./ConfirmDialogOneButton.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogOneButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__